import { ChatEngine } from 'react-chat-engine';
import ChatFeed from './chatComponents/ChatFeed';
//import LoginForm from './chatComponents/LoginForm';
import './chatComponents/chat.css';
import axios from 'axios';
const projectID = '35d72c2f-6947-4fd0-a404-9593ceabe8f6';//3de9d5b1-3a5a-4b30-9098-4103abfe23da

const Chatio = () => {
  let user = JSON.parse(localStorage.getItem('user'));
  const userName = user.userName;
  const password  = "123456";
  //start
  const fetchData = async () => {
      const authObject = {'Project-ID': {projectID}, 
                          'User-Name': {userName}, 
                          'User-Secret': {password} 
                        };
      try {

        await axios.get('https://api.chatengine.io/chats', { headers: authObject });
        //window.location.reload();
      }catch (err) {
        console.log('Oops, incorrect credentials.');
      }
  };
  fetchData();
  //end
  return (
    <ChatEngine
      height="100vh"
      projectID={projectID}
      userName={userName}
      userSecret={password}
      renderChatFeed={(chatAppProps) => <ChatFeed {...chatAppProps} />}
      onNewMessage={() => new Audio('https://chat-engine-assets.s3.amazonaws.com/click.mp3').play()}
    />
  );
};

// infinite scroll, logout, more customizations...

export default Chatio;